import CreateCategory from "@/app/shared/ecommerce/category/create-category";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { Link, useParams } from "react-router-dom";
import { Button } from "rizzui";

const pageHeader = {
    title: "Edit Category",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Home",
        },
        {
            href: routes.eCommerce.categories,
            name: "Categories",
        },
        {
            name: "Edit",
        },
    ],
};

const categoryData = {
    name: "Vegetables",
    slug: "vegetables",
    type: "Diet Foods",
    parentCategory: "Grocery",
    description: "Incredible Granite Ball",
    images: undefined,
};

export default function EditCategoryPage() {
    const { id } = useParams();

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <Link
                    to={routes.eCommerce.categories}
                    className="mt-4 w-full @lg:mt-0 @lg:w-auto"
                >
                    <Button
                        as="span"
                        className="w-full @lg:w-auto"
                        variant="outline"
                    >
                        Cancel
                    </Button>
                </Link>
            </PageHeader>
            <CreateCategory id={id} category={categoryData} />
        </>
    );
}
